import { useScroll, useElementBounding } from '@vueuse/core';

type ScrollBehavior = 'auto' | 'smooth';

export const useScrollToElement = ({
  target,
  window,
  behavior = 'smooth',
  offsetX = 0,
  offsetY = 0,
}: {
  target: MaybeRefOrGetter<HTMLElement | null>;
  window: Ref<(Window & typeof globalThis) | undefined>;
  behavior?: ScrollBehavior;
  offsetX?: MaybeRefOrGetter<number>;
  offsetY?: MaybeRefOrGetter<number>;
}) => {
  const { x: windowX, y: windowY } = useScroll(window, { behavior });
  const { x: targetX, y: targetY } = useElementBounding(target);

  const scrollTo = () => {
    windowX.value += toValue(targetX) + toValue(offsetX);
    windowY.value += toValue(targetY) + toValue(offsetY);
  };

  return { scrollTo };
};
